module.exports = __webpack_public_path__ + "assets/close.420b584e.svg";